/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
import { Header } from './header';
import { ReportContext } from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import { Labels } from './labels';
import { Members } from './members';
import { Pictures } from './pictures';
import { Table } from './table';
import type {
  EventReportData,
  ParsedQuestions,
  QuestionData,
  QuestionsReporData,
} from './types';

export function IssmaPlantioMecanizadoReport(props: {
  reportData: EventReportData;
}) {
  const QUESTIONS_MAP: Record<string, keyof ParsedQuestions> = {
    '222fbd4b-0733-4152-8dd9-9a72622b5a2b': 'local',
    'e88e3b9a-dda1-48e3-b807-de293f3b38b7': 'participante',
    '34a6064d-4ebb-4d75-9141-8a92dbea9d27': 'tipo_inspecao',
    'ed1b9100-0a59-4da8-b078-bd4e73128995': 'responsavel_area',
    '771d722c-76d7-46ed-8cac-6e5ac3b3aa34': 'area',
  };

  const values = Array.isArray(props?.reportData?.body)
    ? props?.reportData?.body?.reduce((acc: Partial<ParsedQuestions>, item) => {
        item.sections?.forEach((section: any) =>
          section.questions.forEach((question: QuestionData) => {
            if (question?.question_id && QUESTIONS_MAP[question.question_id]) {
              acc[QUESTIONS_MAP[question.question_id]] = question;
            }
          }),
        );
        return acc;
      }, {} as Partial<ParsedQuestions>)
    : props?.reportData?.body?.sections?.reduce((acc: Partial<ParsedQuestions>, section) => {
        section.questions.forEach((question: QuestionData) => {
          if (question?.question_id && QUESTIONS_MAP[question.question_id]) {
            acc[QUESTIONS_MAP[question.question_id]] = question;
          }
        });
        return acc;
      }, {} as Partial<ParsedQuestions>);

  const parsedProps: QuestionsReporData = {
    header: props?.reportData?.header,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    body: Array.isArray(props?.reportData?.body)
      ? props?.reportData?.body[0]
      : props?.reportData?.body,
    values,
  };

  return (
    <ReportContext value={parsedProps}>
      <div style={{ breakAfter: 'page' }}>
        <div
          style={{
            height: '90%',
            width: '100vw',
            flex: 1,
            backgroundColor: 'white',
            fontFamily: 'sans-serif',
          }}
        >
          <div
            style={{
              margin: '1rem auto',
              height: 'auto',
              maxWidth: '64rem',
            }}
          >
            <Header formName={parsedProps.body?.form_name} />
            <div
              style={{
                height: '100%',
                width: '100%',
                borderRadius: '2px',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#000',
                backgroundColor: '#fff',
              }}
            >
              <InitialInfos />
              <Table />
              <Members />
              <Labels />
              <Pictures />
            </div>
          </div>
        </div>
      </div>
    </ReportContext>
  );
}
